"use strict";
/**
 * Created on 05 17 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link AppRecalcInitiation}.</p>
 *
 * @author JMe
 */


var AppRecalcInitiationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(AppRecalcInitiationConverter, _DataObjectConverter_);

  function AppRecalcInitiationConverter() {
    _classCallCheck(this, AppRecalcInitiationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppRecalcInitiationConverter).apply(this, arguments));
  }

  return AppRecalcInitiationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.AppRecalcInitiationConverter = AppRecalcInitiationConverter;